import { TDownloadLaborPosterTemplateRequestSchema } from "./downloadLaborPosterTemplate.schema";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";

export const downloadLaborPosterTemplate = (axios: IAxiosInstance) => {
  return async (
    payload: TDownloadLaborPosterTemplateRequestSchema
  ): Promise<Blob> => {
    const response = await axios.noRetry.post<Blob>(
      `/labor-posters/template`,
      payload,
      {
        responseType: "blob",
        timeout: 120000,
      }
    );

    return response.data;
  };
};
